import { BlockRenderer } from "@/components/test/BlockRenderer";
import type { TestTask } from "@/lib/testTypes";

type Props = {
  task: TestTask;
  showAnswers: boolean;
};

export function TaskRenderer({ task, showAnswers }: Props) {
  return (
    <div className="space-y-3">
      {task.blocks.map((block, i) => (
        <BlockRenderer
          key={i}
          block={block}
          blockIndex={i}
          answers={task.answers}
          showAnswers={showAnswers}
        />
      ))}
    </div>
  );
}
